import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <div style={{
            display: 'inline-block',
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            padding: '40px 48px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            maxWidth: '500px',
          }}>
            <div style={{ fontSize: '2rem', marginBottom: '16px' }}>⚠️</div>
            <h4 style={{ color: '#022040', marginBottom: '8px' }}>Error al cargar esta página</h4>
            <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '20px' }}>
              {this.state.error && this.state.error.message}
            </p>
            <button
              style={{
                background: 'linear-gradient(135deg, #022040, #0a4080)',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '10px 24px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 600,
              }}
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Reintentar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
